var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"dense":"","text":"","type":"success"}},[_vm._v(" Score Earned: "+_vm._s(_vm.score ? _vm.score.toFixed(3) : this.noNum.toFixed(3))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }